import React from "react";
import AdminContainer from 'containers/AdminContainer';
import ProductCouponsList from './ProductCouponsList';

function ProductCouponsTab() {
  return (
    <AdminContainer>
      <div className="page-heading buyerDetailsHeader d-sm-flex justify-content-sm-between align-items-sm-center">
        <h2 className="title mb-3 mb-sm-0">Coupons &amp; Gifts</h2>
      </div>
      <ProductCouponsList />
    </AdminContainer>
  );
}

export default ProductCouponsTab;
